import useLanguage from "../i18n/useLanguage";
import React from "react";

export default function Contact() {
  const { t } = useLanguage();
  return (
    <section
      id="contact"
      className="min-h-screen bg-black text-white flex flex-col items-center justify-center relative py-20"
    >
      <div className="flex flex-col items-center gap-16 w-full max-w-5xl px-6 md:px-8">
        {/* top divider */}
        <div className="w-full max-w-7xl h-px bg-gray-300"></div>

        {/* main content */}
        <div
          className="
            flex
            items-center
            justify-center
            gap-6 sm:gap-8 md:gap-12
            w-full
            max-w-4xl
            mx-auto
          "
        >
          {/* left text */}
          <div className="flex flex-col items-end sm:items-end">
            <p className="text-gray-300 text-base sm:text-base md:text-lg mb-4 md:mb-6 tracking-wider font-bold text-right">{t("GET IN TOUCH")}{" "}</p>

            <h2
              className="
                text-white
                text-3xl sm:text-3xl md:text-5xl lg:text-6xl
                font-bold
                leading-tight
                max-w-[220px] sm:max-w-xs md:max-w-lg
                text-right
              "
            >{t("Let's")}{" "}<br />{t("build something together.")}{" "}</h2>
          </div>

          {/* VERTICAL DIVIDER (TETAP) */}
          <div className="w-px h-48 sm:h-56 md:h-72 bg-gray-300" />

          {/* button */}
          <div className="flex shrink-0 items-center">
            <a
              href="https://wa.me/62881011844173"
              target="_blank"
              rel="noopener noreferrer"
              className="
                rounded-2xl
                border border-gray-300
                text-white
                text-lg sm:text-xl md:text-2xl
                whitespace-nowrap px-4 md:px-8 min-h-14
                font-bold
                hover:bg-white hover:text-black
                transition-all duration-300
                flex items-center justify-center
              "
            >{t("Contact Us")}{" "}</a>
          </div>
        </div>

        {/* bottom divider */}
        <div className="w-full max-w-7xl h-px bg-gray-300"></div>
      </div>
    </section>
  );
}
